import React from 'react';
import { Spacer } from '@tink/core/src/components/atoms/Spacer/Spacer';
import { ArrowRight } from '@tink/core/src/components/atoms/Icons/ArrowRight';
import { ProviderField, SelectOption } from '../../../../../../../models/provider';

import { H1 } from '../../../../../../atoms/Heading/Heading';
import { CircledIcon } from '../../../../../../atoms/Icons/CircledIcon';
import { SelectableOption } from '../../../../../molecules/SelectableOption/SelectableOption';
import { StyledLogo } from '../../../../../molecules/SelectableOption/molecules/ListItem/ListItem.styles';
import { SubmitProviderInputsPayload } from '../../../../../SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { ContentBody } from '../../../../../../atoms/ContentBody/ContentBody';

export type SingleSelectableOptionViewProps = {
  field: ProviderField;
  handleSubmit: (values: SubmitProviderInputsPayload) => void;
};

export const SingleSelectableOptionView: React.FC<SingleSelectableOptionViewProps> = ({
  field: { name, selectOptions, description },
  handleSubmit,
}: SingleSelectableOptionViewProps) => (
  <ContentBody data-testid="SingleSelectableOptionScreen">
    <H1>{description}</H1>
    <Spacer size="xxsmall" />
    {(selectOptions as SelectOption[]).map(({ value, text, iconUrl }) => {
      return (
        <SelectableOption
          key={value}
          text={text}
          Icon={iconUrl ? <StyledLogo src={iconUrl} alt="" /> : <CircledIcon Icon={ArrowRight} />}
          onClick={() => {
            handleSubmit({ [name]: value });
          }}
        />
      );
    })}
  </ContentBody>
);
